import React from 'react'
import { Button } from "@material-ui/core"

function CleanButton({ classes, ...props }) {
  return <Button size='small' style={{ borderRadius: '0px' }} {...props} />
}

export default CleanButton